import React from 'react'
import { useContent } from '../../services'
import Backgroundimage from '../../assets/images/background/image-12.jpg';

function Quotesection() {
  const { data, loading } = useContent('teamContent');

  if (loading || !data) return null;

  const { quoteSection } = data.chefPage;

  return (
    <>
      <section className="intro-section quote">
        <div className="image-layer" style={{ backgroundImage: `url(${Backgroundimage})` }}></div>
        <div className="auto-container">
          <div className="content-box">
            <h3>{quoteSection.quote}</h3>
            <div className="separator"><span></span><span></span><span></span></div>
            <div className="auth-title">{quoteSection.author}</div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Quotesection
